var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reservation-preorder-detail-page',{attrs:{"type":_vm.type,"mode":_vm.mode,"patient-id":_vm.patientId,"reservation-id":_vm.resolvedReservationId,"origin":_vm.$route.params.origin,"origin-data":_vm.$route.params.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }